import classNames from "classnames";
import { validate } from "../../utils/validate";
import { DComponent } from "../DComponent";
import { GLOBAL_CONSTANTS } from "../../global/constants";

export default class SelectBox extends DComponent {
  constructor({
    parent,
    id,
    label = "",
    labelText = "",
    tabIndex = "",
    invalid = "",
    placeholder = "",
    isRequired = false,
    options = {},
    inline = false,
    hideFeedback = false,
    autoScroll = false,
    scrollPadding = 256,
    scrollParent,
    onBlur = () => { },
    onDropdownOpen = () => { },
    onChange = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("SelectBox", {
        "is-required": isRequired,
        "inline": inline,
        "hide-feedback": hideFeedback,
      }),
      label: label,
      labelText: labelText,
      tabIndex: tabIndex,
      invalid: invalid,
    });
    this.placeholder = placeholder;
    this.isRequired = isRequired;
    this.options = options;
    this.onBlur = onBlur;
    this.onDropdownOpen = onDropdownOpen;
    this.onChange = onChange;
    this.autoScroll = autoScroll;
    this.scrollPadding = scrollPadding;
    this.scrollParent = scrollParent;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "SelectBox");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    const { onDropdownOpen, onBlur, onChange, element, options } = this;
    $("select", this.element).selectize({
      searchField: ['value', 'text'],
      onDropdownOpen: function () {
        this.latest = this.getValue() || this.latest;
        this.$input.get(0).selectize.clear(true);
        if (typeof (onDropdownOpen) === "function") {
          onDropdownOpen();
        }
      },
      onBlur: function (e) {
        if (this.getValue() === '') {
          this.setValue(this.latest);
          if (typeof (onBlur) === "function") {
            onBlur(e);
          }
        }
      },
      onChange: function (value, e) {
        $(".option", this.$dropdown_content).removeClass("selected");
        if (value && value !== this.latest) {
          validate({ selector: $("select", element), ignore: true });
          if (typeof (onChange) === "function") {
            onChange(value);
          }
        }
      },
      ...options,
      placeholder: "Select...",
    });
    if (this.placeholder) {
      $("select", this.element).parent().find("input").attr("data-i18n", `[placeholder]${this.placeholder}`);
      $("select", this.element).parent().find("input").attr("placeholder", $.i18n(this.placeholder));
    }
    if (this.autoScroll) {
      $("select", this.element).parent().find("input").attr("autoscroll", "");
      this.scrollPadding !== undefined && $("select", this.element).parent().find("input").attr("scrollpadding", this.scrollPadding);
      this.scrollParent && $("select", this.element).parent().find("input").attr("scrollparent", this.scrollParent);
    }
  }

  addOption(options, text = "label", value = "value", isNotFocus = true) {
    if (options && options.length > 0) {
      var control = $("select", this.element).selectize()[0].selectize;
      control.clear();
      control.clearOptions();
      options.forEach(element => {
        const option = new Option(element[text], element[value], false, false);
        $(option).attr(this.options?.dataAttr || "data-search", JSON.stringify(element));
        control.addOption(option);
      });
      if (this.placeholder) {
        setTimeout(() => {
          this.setPlaceholder($.i18n(this.placeholder));
        }, 0);
      }
      if (!isNotFocus) {
        control.focus();
      }
    }
  }

  setPlaceholder(placeholder) {
    let selectize = $("select", this.element).selectize()[0].selectize;
    selectize.settings.placeholder = placeholder
    selectize.updatePlaceholder()
  }

  getLatest() {
    return $("select", this.element)[0].selectize.latest;
  }

  setLatest(lastest) {
    $("select", this.element)[0].selectize.latest = lastest;
  }

  getValue() {
    return $("select", this.element).val();
  }

  getLabel() {
    return $("select", this.element).text();
  }


  setValue(value, noOnChange = true) {
    value ? this.element.addClass("has-value") : this.element.removeClass("has-value");
    $("select", this.element)[0].selectize.setValue(value, noOnChange);
  }

  clearInput() {
    this.element.removeClass("has-value");
    $("select", this.element).removeClass("is-invalid");
    $("select", this.element)[0].selectize.$input.get(0).selectize.clear(true);
  }

  focus() {
    $("select", this.element)[0].selectize.focus();
  }

  blur() {
    $("input", this.element).blur();
  }

  close() {
    $("select", this.element)[0].selectize.close();
  }

  isValidate(isShowValid = true, isFocus = true) {
    if (!this.isRequired) return true;
    return validate({ selector: $("select", this.element), showInvalid: isShowValid, type: GLOBAL_CONSTANTS.INPUT_TYPE.SELECT, isFocus: isFocus });
  }
}